import React from 'react';
import { Download, Loader2, X, AlertCircle } from 'lucide-react';

export const ExportModal = ({ isOpen, onClose, onExport, exportStatus, projectName, bpm, totalBars, trackCount }) => {
  if (!isOpen) return null;

  return (
    <div data-testid="export-modal" className="fixed inset-0 z-50 flex items-center justify-center" style={{ background: 'rgba(0,0,0,0.7)' }}>
      <div className="flex flex-col" style={{ width: 420, background: 'var(--bg-card)', borderRadius: 16, border: '1px solid var(--border)', overflow: 'hidden' }}>
        <div className="flex items-center justify-between px-5 py-4 border-b" style={{ borderColor: 'var(--border)' }}>
          <div className="flex items-center gap-2">
            <Download size={18} style={{ color: 'var(--green)' }} />
            <span style={{ fontSize: 16, fontWeight: 700, color: 'var(--text)' }}>Export MP3</span>
          </div>
          <button data-testid="close-export" onClick={onClose} style={{ width: 28, height: 28, borderRadius: 8, background: 'var(--bg-elevated)', color: 'var(--text-dim)', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <X size={14} />
          </button>
        </div>

        <div className="flex flex-col items-center py-6 px-6 gap-4">
          {/* Project info */}
          <div className="flex items-center gap-3 w-full px-3 py-2" style={{ background: 'var(--bg-elevated)', borderRadius: 10, border: '1px solid var(--border)' }}>
            <div className="flex flex-col flex-1">
              <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)' }}>{projectName || 'Untitled Beat'}</span>
              <span style={{ fontSize: 11, color: 'var(--text-dim)' }}>{bpm} BPM | {totalBars} bars | {trackCount} tracks</span>
            </div>
          </div>

          {/* Idle state */}
          {(!exportStatus || exportStatus === 'idle') && (
            <>
              <p className="text-center" style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.6 }}>
                Your beat will be rendered as a high-quality MP3 and downloaded to your computer.
              </p>
              <button
                data-testid="start-export"
                onClick={onExport}
                className="flex items-center gap-2"
                style={{ height: 44, borderRadius: 22, padding: '0 28px', fontSize: 14, fontWeight: 600, background: 'var(--green)', color: 'var(--bg)', border: 'none', cursor: 'pointer' }}
              >
                <Download size={16} /> Export MP3
              </button>
            </>
          )}

          {/* Rendering state */}
          {exportStatus === 'rendering' && (
            <div className="flex flex-col items-center gap-3 py-4">
              <Loader2 size={32} className="animate-spin" style={{ color: 'var(--green)' }} />
              <span data-testid="export-rendering" style={{ fontSize: 14, fontWeight: 600, color: 'var(--text)' }}>Rendering your beat...</span>
              <span style={{ fontSize: 11, color: 'var(--text-dim)' }}>This may take a few seconds</span>
            </div>
          )}

          {/* Success state */}
          {exportStatus === 'success' && (
            <div className="flex flex-col items-center gap-3 py-4">
              <img src="/pizzul/satisfied.png" alt="Pizzul is satisfied with your beat" style={{ width: 96, height: 96, objectFit: 'contain' }} />
              <span data-testid="export-success" style={{ fontSize: 16, fontWeight: 700, color: 'var(--green)' }}>Your beat is ready!</span>
              <span style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Check your downloads.</span>
            </div>
          )}

          {/* Error state */}
          {exportStatus === 'error' && (
            <div className="flex flex-col items-center gap-3 py-4">
              <AlertCircle size={32} style={{ color: 'var(--pink)' }} />
              <span data-testid="export-error" style={{ fontSize: 14, fontWeight: 600, color: 'var(--pink)' }}>Export failed. Try again.</span>
              <button
                data-testid="retry-export"
                onClick={onExport}
                className="flex items-center gap-2"
                style={{ height: 40, borderRadius: 22, padding: '0 24px', fontSize: 13, fontWeight: 600, background: 'var(--green)', color: 'var(--bg)', border: 'none', cursor: 'pointer' }}
              >
                <Download size={15} /> Try Again
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExportModal;
